export default __webpack_public_path__ + "static/media/bottom-nav-bg.eb3a86bd.webp";